module.exports = __webpack_public_path__ + "static/media/400035_02.6e00976c.png";